import React from 'react';
import { motion } from 'framer-motion';
type Variant = 'red' | 'yellow' | 'blue' | 'black' | 'white';
interface MondrianButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  children: React.ReactNode;
  fullWidth?: boolean;
}
const variants = {
  red: 'bg-mondrian-red text-white hover:bg-red-600',
  yellow: 'bg-mondrian-yellow text-black hover:bg-yellow-400',
  blue: 'bg-mondrian-blue text-white hover:blue-700',
  black: 'bg-mondrian-black text-white hover:bg-gray-900',
  white: 'bg-mondrian-white text-black hover:bg-gray-100'
};
export function MondrianButton({
  variant = 'black',
  children,
  className = '',
  fullWidth = false,
  ...props
}: MondrianButtonProps) {
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`
        ${variants[variant]}
        ${fullWidth ? 'w-full' : ''}
        border-4 border-mondrian-black
        px-6 py-3
        font-bold uppercase tracking-wider
        sharp-corners
        transition-colors duration-200
        focus:outline-none focus:ring-4 focus:ring-mondrian-black/20
        disabled:opacity-50 disabled:cursor-not-allowed
        ${className}
      `} {...props} data-id="element-245">
      {children}
    </motion.button>;
}